import Page from 'src/components/page/Page';
import CustomerTable from './components/CustomerTable';

const CustomersPage = () => {
  return (
    <Page title="Customers">
      <CustomerTable />
    </Page>
  );
};

export default CustomersPage;
